import { createFileRoute } from '@tanstack/react-router'
import { AnalyticsShell } from '../../../modules/analytics/analytics-shell'
import { SavedReportsTable } from '../../../modules/analytics/components/dashboard/saved-reports-table'

/**
 * `/analytics/reports` - saved analytics views + scheduled reports (PDF/CSV
 * delivery; preview available in mock mode).
 */
export const Route = createFileRoute('/_authed/analytics/reports')({
  component: () => (
    <AnalyticsShell padded>
      <SavedReportsTable />
    </AnalyticsShell>
  ),
})
